/* Metal switcher — recompute every "from" price for the metal the visitor picks.
 *
 * Why this exists: every GTU design can be made in Silver, 10K, 14K or 18K. Metal is an
 * option, not a property of the piece, so filtering by metal would return the whole
 * catalogue. What a visitor actually wants is "show me these prices in 14K".
 *
 * The maths mirrors eg-product-card.liquid and eg-preset-configurator.js:
 *   $40 base + caps x perTooth + stones x 5 + precious x 120
 *            + fangs x fangSmall + gaps x gapSmall + customDesignTier
 * Per-tooth, fang and gap rates all come from gtu.pricing_matrix, and Top and Bottom are
 * charged differently, so each card carries its own position.
 *
 * Progressive enhancement: with JS off the server-rendered Silver price stands and the
 * switcher never appears.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-metal-switch]');
  if (!root) return;

  var matrix;
  try {
    matrix = JSON.parse(document.getElementById('eg-pricing-matrix').textContent);
  } catch (e) {
    return; // no matrix, leave the Silver prices alone
  }
  if (!matrix || !matrix.Top) return;

  var STORE_KEY = 'gtu:metal';
  var BASE = 40;
  var MOISSANITE = 5;
  var OPAL = (matrix.Precious && matrix.Precious.opal) || 120;

  function rate(group, metal) {
    var g = matrix[group];
    if (!g) return 0;
    return Number(g[metal] || g.Silver || 0);
  }

  function componentRate(group, size, metal) {
    var g = matrix[group];
    if (!g || !g[size]) return 0;
    return Number(g[size][metal] || g[size].Silver || 0);
  }

  function priceFor(card, metal) {
    var caps = Number(card.dataset.caps || 0);
    if (!caps) return null; // card falls back to product.price, nothing to recompute
    var pos = card.dataset.pos === 'Bottom' ? 'Bottom' : 'Top';
    var total = BASE;
    total += caps * rate(pos, metal);
    total += Number(card.dataset.stones || 0) * MOISSANITE;
    total += Number(card.dataset.precious || 0) * OPAL;
    total += Number(card.dataset.fangs || 0) * componentRate('Fangs', 'small', metal);
    total += Number(card.dataset.gaps || 0) * componentRate('Gaps', 'small', metal);
    total += Number(card.dataset.custom || 0);
    return total;
  }

  function money(n) {
    return '$' + Math.round(n).toLocaleString('en-US') + '.00';
  }

  function apply(metal) {
    var cards = document.querySelectorAll('.eg-product-card[data-caps]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var priceEl = card.querySelector('[data-metal-price]');
      var labelEl = card.querySelector('[data-metal-label]');
      if (!priceEl) continue;
      var p = priceFor(card, metal);
      if (p === null) continue;
      priceEl.textContent = money(p);
      if (labelEl) labelEl.textContent = metal + ' price from';
    }
    var btns = root.querySelectorAll('[data-metal]');
    for (var j = 0; j < btns.length; j++) {
      btns[j].classList.toggle('on', btns[j].dataset.metal === metal);
      btns[j].setAttribute('aria-pressed', btns[j].dataset.metal === metal ? 'true' : 'false');
    }
    try { localStorage.setItem(STORE_KEY, metal); } catch (e) { /* private mode */ }
  }

  root.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-metal]');
    if (!btn) return;
    ev.preventDefault();
    apply(btn.dataset.metal);
  });

  // Remember the choice across pages. Silver is already rendered, so only act on a change.
  var saved = null;
  try { saved = localStorage.getItem(STORE_KEY); } catch (e) { /* ignore */ }
  if (saved && saved !== 'Silver' && matrix.Top[saved]) apply(saved);
})();
